/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {LayoutExampleListPageComponent} from './layout-example-list-page.component';

@Component({
  standalone: true,
  imports: [LayoutExampleListPageComponent],
  selector: 'adn-layout-example-route-page',
  template: '<adn-layout-example-list-page></adn-layout-example-list-page>'
})
export class LayoutExampleRoutePageComponent {
}
